export default {"src":"/_next/static/media/cards-icon-3.9ea0304d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};